const TIMEZONE = "Australia/Sydney";
const LOCALE = "en-AU";

/**
 * Format a date in Australian Eastern time.
 * @param date - Date object or date string/timestamp
 * @param options - Intl.DateTimeFormat options (defaults to day, month, year)
 */
export const formatDateAU = (
  date: Date | string | number,
  options: Intl.DateTimeFormatOptions = { day: "numeric", month: "long", year: "numeric" },
): string => {
  return new Date(date).toLocaleString(LOCALE, { timeZone: TIMEZONE, ...options });
};

/**
 * Format a date as "MMMM YYYY" in Australian Eastern time (e.g. "June 2026").
 */
export const formatMonthYearAU = (date: Date | string | number): string => {
  return formatDateAU(date, { month: "long", year: "numeric" });
};

/**
 * Format a date as "DD MMMM YYYY" in Australian Eastern time (e.g. "3 June 2026").
 */
export const formatFullDateAU = (date: Date | string | number): string => {
  return formatDateAU(date, { day: "numeric", month: "long", year: "numeric" });
};

/**
 * Format a date as "MMM YYYY" in Australian Eastern time (e.g. "Jun 2026").
 */
export const formatShortMonthYearAU = (date: Date | string | number): string => {
  return formatDateAU(date, { month: "short", year: "numeric" });
};
